<span class="timer-value fw-700" *ngIf="!isExpired; else expiredTpl">
    <!-- {{ days }}:{{ hours }}:{{ minutes }}:{{ seconds }} -->
   {{ hours }} giờ {{ minutes }} phút {{ seconds }} giây
</span>

<ng-template #expiredTpl>
  <span class="expired">⏰ Đã hết hạn!</span>
</ng-template>
